import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import 'normalize.css';

// import App from './components/App';
import App from './containers/App';
import reducers from './reducers';
import './globalStyles';

const store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

ReactDOM.render(
  <Provider store={store}><App /></Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js